module.exports = __webpack_public_path__ + "static/media/S1N13.3870e3b6.svg";